import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["step", "indicator", "line", "label"]

  connect() {
    this.currentStep = 0
    this.showStep()
  }

  next(event) {
    if (!this.validateStep()) {
      event.preventDefault()
      return
    }

    if (this.currentStep < this.stepTargets.length - 1) {
      this.currentStep++
      this.showStep()
    }
  }

  previous() {
    if (this.currentStep > 0) {
      this.currentStep--
      this.showStep()
    }
  }

  validateStep() {
    const currentStepFields =
      this.stepTargets[this.currentStep].querySelectorAll("input, textarea")
    let isValid = true

    currentStepFields.forEach((field) => {
      if (!field.value.trim()) {
        field.classList.add("border-red-500")
        isValid = false
      } else {
        field.classList.remove("border-red-500")
      }
    })

    return isValid
  }

  showStep() {
    this.stepTargets.forEach((el, index) => {
      el.classList.toggle("hidden", index !== this.currentStep)
    })

    this.indicatorTargets.forEach((el, index) => {
      el.classList.remove(
        "bg-secondary-900",
        "border-blue-500",
        "text-white",
        "bg-gray-300",
        "border-gray-300",
        "text-gray-500",
        "bg-green-500",
        "border-green-500"
      )

      if (index < this.currentStep) {
        el.classList.add(
          "bg-secondary-900",
          "border-secondary-900",
          "text-white"
        )
      } else if (index === this.currentStep) {
        el.classList.add(
          "bg-secondary-900",
          "border-secondary-900",
          "text-white"
        )
      } else {
        el.classList.add("bg-gray-300", "border-gray-300", "text-gray-500")
      }
    })

    this.lineTarget.classList.remove("bg-secondary-900", "bg-gray-300")
    this.lineTarget.classList.add(
      this.currentStep > 0 ? "bg-secondary-900" : "bg-gray-300"
    )

    this.labelTargets.forEach((el, index) => {
      el.classList.remove("text-blue-500", "font-semibold", "text-gray-500")
      el.classList.add(
        index <= this.currentStep
          ? "text-Secondary-900 font-semibold"
          : "text-gray-500"
      )
    })
  }
}
